import {
  BenefitDto,
  PlanMarket,
  SelfEnrollType,
  SupplementalPlanForEnrollment,
} from '@zorro/clients';
import { formatDateISO, getNow } from '@zorro/shared/formatters';
import { exportToCsv, getWhoIsEnrolled } from '@zorro/web/ui-utils';

import {
  PlanElectionItem,
  PlanElectionItemFormFields,
} from '../PlanElectionForm';

export const getEmptySupplementalPlanFormFields = (
  allWhoIsEnrolled: string[]
): PlanElectionItemFormFields => {
  return {
    whoIsEnrolled: allWhoIsEnrolled,
    isMedicareCoverage: false,
    isHsaEligible: false,
    isSelfEnroll: false,
    planName: '',
    premium: 0,
  };
};

export const getDefaultSupplementalPlanFormFields = (
  benefits: BenefitDto[] = [],
  allWhoIsEnrolled: string[]
): PlanElectionItemFormFields[] => {
  if (benefits.length === 0) {
    return [getEmptySupplementalPlanFormFields(allWhoIsEnrolled)];
  }

  return benefits.map(({ plan, insuredPeople }) => ({
    whoIsEnrolled: insuredPeople ? getWhoIsEnrolled(insuredPeople) : [],
    isSelfEnroll: plan?.selfEnroll === SelfEnrollType.SELF_ENROLL,
    benefitsSummaryUrl: plan?.benefitsSummaryUrl ?? undefined,
    maxOutOfPocket: plan?.maxOutOfPocket ?? undefined,
    isHsaEligible: plan?.isHsaEligible ?? undefined,
    deductible: plan?.deductible ?? undefined,
    planId: plan?.externalID ?? undefined,
    planMarket: plan?.planMarket,
    policyType: plan?.policyType,
    premium: plan?.premium ?? 0,
    planName: plan?.name ?? '',
    carrier: plan?.carrierName,
    isMedicareCoverage: false,
  }));
};

const fields = [
  { value: 'id' },
  { value: 'name' },
  { value: 'carrierName' },
  { value: 'carrierId' },
  { value: 'benefitsSummaryUrl' },
  { value: 'selfEnroll' },
  { value: 'policyType' },
  { value: 'logoUrl' },
  { value: 'premium' },
  { value: 'deductible' },
  { value: 'maxOutOfPocket' },
];

export function exportSupplementalPlanList(
  data: SupplementalPlanForEnrollment[],
  employeeFullName: string,
  employerName: string = ''
) {
  const today = formatDateISO(getNow());
  const fileName = `plans_${employerName}_${employeeFullName}_${today}.csv`;

  return exportToCsv(data, fileName, fields);
}

export const mapSupplementalPlanToPlanElectionItem = (
  visionPlans?: SupplementalPlanForEnrollment[]
): PlanElectionItem[] | undefined => {
  return visionPlans?.map((visionPlan) => ({
    id: visionPlan.id,
    carrierName: visionPlan.carrierName,
    name: visionPlan.name,
    premium: visionPlan.premium,
    hsaEligible: null,
    deductible: visionPlan.deductible,
    maxOutOfPocket: visionPlan.maxOutOfPocket,
    benefitsSummaryUrl: visionPlan.benefitsSummaryUrl,
    planMarket: PlanMarket.OFF_EXCHANGE,
    selfEnroll: visionPlan.selfEnroll,
    policyType: visionPlan.policyType,
    extendedPlanDetails: null,
    hasVisionRider: visionPlan.hasVisionRider,
  }));
};
